/* unplugin-vue-components disabled */import script from "./Document.vue?vue&type=script&setup=true&lang=js"
export * from "./Document.vue?vue&type=script&setup=true&lang=js"

import "./Document.vue?vue&type=style&index=0&id=9ac9c42c&lang=less"

const __exports__ = script;

export default __exports__